import { Extension } from '@tiptap/core';
import { BhsnBlockReferenceExtension } from './BhsnBlockReferenceExtension';
import { BhsnBlockReferenceUnlinkExtension } from './BhsnBlockReferenceUnlinkExtension';
import { BhsnReferenceExtension } from './BhsnReferenceExtension';
import { BhsnReferenceUnlinkExtension } from './BhsnReferenceUnlinkExtension';
import { BhsnSlotReferenceExtension } from './BhsnSlotReferenceExtension';

export interface BhsnExtensionPackOptions {
    [key: string]: unknown;
}

export const BhsnNormalExtensionPack = Extension.create<BhsnExtensionPackOptions>({
    name: 'bhsnExtensionPack',

    addExtensions() {
        const extensions = [BhsnBlockReferenceUnlinkExtension, BhsnReferenceUnlinkExtension];
        return extensions;
    },
});

export const BhsnStandardFormExtensionPack = Extension.create<BhsnExtensionPackOptions>({
    name: 'bhsnExtensionPack',

    addExtensions() {
        const extensions = [BhsnBlockReferenceExtension, BhsnReferenceExtension, BhsnSlotReferenceExtension];
        return extensions;
    },
});
